module.exports = __webpack_public_path__ + "img/trial3-2.94a136dd.png";